import React from 'react';
import { ComingSoonPage } from './ComingSoonPage';

export function BillingSettings() {
  return (
    <ComingSoonPage
      title="Billing & Subscription"
      description="Manage your subscription plan, billing information, usage tracking, and payment methods."
      estimatedDate="Q1 2024"
      icon={
        <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
        </svg>
      }
      features={[
        "View and manage subscription plans and pricing",
        "Track usage statistics and billing cycles",
        "Update payment methods and billing information",
        "Download invoices and payment history",
        "Manage team member billing permissions",
        "Set up billing alerts and usage limits"
      ]}
    />
  );
}
